import React, { useState, useEffect , useContext} from "react";
import { useLocation } from "react-router-dom";
import { useNavigate ,useParams } from "react-router-dom";
import Image from "../../../images/Place Holder 3 1.png";
import NoIndex from "../../NoIndex";
import "../AdminDashboard.css"
import MyContext from "../../../MyContext";

const AdminTemplateView = ({ userID }) => {
  const {baseUrl, config}= useContext(MyContext);
    const { clientId } = useParams();
    const { templateId } = useParams();
      const navigate = useNavigate();
      const location = useLocation();
const [templates, setTemplates] = useState([]);
  const [TemplateIndex, setTemplateIndex] = useState("");
  const [templateName, setTemplateName] = useState("");
  const [Details, setDetails] = useState(true);

  const handleEditClick = () => {
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("templateIndex");
    console.log("Clicked row with campaignId:", id);

    navigate(`/WhatsApp/Template/TemplateEdit?templateID=${TemplateIndex}`);
  };

  const getQueryParams = () => {
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("templateId");
    const name = searchParams.get("templateName");
    setTemplateIndex(id);
    setTemplateName(name);
    console.log("Template Name:", name);
    console.log("Template Index:", id);
    setDetails(true);
  };

  useEffect(() => {
    getQueryParams();
  }, [location.search]); // Re-run the effect when the search query changes


  const getTemplateDetail = async () => {
    // if (!templateId) return;

    try {

      var raw = JSON.stringify({
        userid: clientId,
        secret: "string",
        templateId: templateId,
      });

      var requestOptions = {
        method: "POST",
        headers: config.headers,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${baseUrl}/api/Whatsapp/getTemplateDetails`,
        requestOptions
      );

      const data = await res.json();

      if (data?.responseCode === "00") {
        setTemplates(data?.response);
      } else {
        console.error("Error fetching template details:", data?.message);
      }
    } catch (error) {
      console.error("Error fetching template details:", error);
    }
  };

  useEffect(() => {
    getTemplateDetail();
  }, []);
 

  return (
     <div className="marginRight">
         <NoIndex />
         <div
           className="p-4 bg-white"
           style={{
             height: "100vh",
             fontFamily: "Nunito,sans-serif",
           }}
         >
           <div className="px-4 justify-content-center">
             <div className="d-flex justify-content-between">
               <p className="CreateCampaign">Template Details</p>
               {/* <p>
                 <button
                   className="blue-button p-2 px-4 me-3 text-white"
                   onClick={handleEditClick}
                 >
                   Edit
                 </button>
               </p> */}
             </div>
             <div className="px-2">
               <div
                 className="pt-2 row col-12"
                 style={{
                   borderRadius: "10px",
                   backgroundColor: "#fffff",
                 }}
               >
                 {Details && templates.name === templateId ? (
                   <div
                     className="p-4 d-flex justify-content-between"
                     style={{ border: "1px solid #cccc", borderRadius: "10px" }}
                   >
                     <div
                       className="bg-white p-3"
                       style={{ borderRadius: "10px" }}
                     >
                      <div className="campaignBoxName d-flex">
     <b>Template ID :</b>
     <p className="mx-2">{templates.id || "Null"}</p>
   </div>
   
   <div className="campaignBoxName d-flex">
     <b>Template Name :</b>
     <p className="mx-2">{templates.name || "Null"}</p>
   </div>
   
   <div className="campaignBoxName d-flex">
     <b>Language :</b>
     <p className="mx-2">{templates.language || "Null"}</p>
   </div>
   
   <div className="campaignBoxName d-flex">
     <b>Status :</b>
     <p className="mx-2">{templates.status || "Null"}</p>
   </div>
   
   <div className="campaignBoxName d-flex">
     <b>Category :</b>
     <p className="mx-2">{templates.category || "Null"}</p>
   </div>
   
   <div className="campaignBoxName d-flex">
     <b>Header Type :</b>
     <p className="mx-2">
       {templates.components.find(item => item.type === "HEADER")?.format || "Null"}
     </p>
   </div>
   
   <div className="campaignBoxName d-flex">
     <b>Header Text :</b>
     <p className="mx-2">
       {templates.components.find(item => item.type === "HEADER")?.text || "Null"}
     </p>
   </div>
   
   <div className="campaignBoxName d-flex">
     <b>Body Type :</b>
     <p className="mx-2">
       {templates.components.find(item => item.type === "BODY")?.format || "Null"}
     </p>
   </div>
   
   <div className="campaignBoxName d-flex">
     <b>Body Text :</b>
     <p className="mx-2">
       {templates.components.find(item => item.type === "BODY")?.text || "Null"}
     </p>
   </div>
   
   <div className="campaignBoxName d-flex">
     <b>Footer Text :</b>
     <p className="mx-2">
       {templates.components.find(item => item.type === "FOOTER")?.text || "Null"}
     </p>
   </div>
   
   <div className="campaignBoxName d-flex">
     <b>Buttons :</b>
     <p className="mx-2">
       {templates.components.find(item => item.type === "BUTTONS")?.buttons?.length > 0
         ? templates.components.find(item => item.type === "BUTTONS")?.buttons.map((btn, index) => (
             <a key={index} href={btn.url} target="_blank" rel="noopener noreferrer">
               {btn.text}
             </a>
           ))
         : "No Buttons"}
     </p>
   </div>
   
   
                     </div>
   
                     <div className="col-6 d-flex justify-content-end">
                     <div className="mobile-card"style={{position:"relative"}}>
     <div className="mobile-btn1"></div>
     <div className="mobile-btn2"></div>
     <div className="mobile-btn3"></div>
     <div className="mobile-btn4"></div>
   
     <div className="mobile-card-int">
       <div className="bubble-container">
         <div className="message-bubble message-bubble-animate">
           {/* Check if video exists and display it */}
           {templates.components.find(item => item.format === "VIDEO")?.example?.header_handle?.[0] ? (
             <video width="90%" height="200px" controls>
               <source
                 src={templates.components.find(item => item.format === "VIDEO")?.example?.header_handle?.[0]}
                 type="video/mp4"
               />
               Your browser does not support the video tag.
             </video>
           ) : templates.components.find(item => item.format === "IMAGE")?.example?.header_handle?.[0] ? (
             // Check if image exists and display it
             <img
               src={templates.components.find(item => item.format === "IMAGE")?.example?.header_handle?.[0]}
               alt="Template Image"
               style={{ maxWidth: "90%", borderRadius: "8px" }}
             />
           ) : null}
   
           {/* Header Text */}
           <div className="header-text">
             {templates.components.find(item => item.type === "HEADER")?.text || ""}
           </div>
   
           {/* Body Text */}
           <div className="body-text py-1">
             <div>{templates.components.find(item => item.type === "BODY")?.text || ""}</div>
           </div>
   
           {/* Footer Text */}
           <div className="footer-text">{templates.components.find(item => item.type === "FOOTER")?.text || ""}</div>
   
           {/* Time Display */}
           <div className="footer-text text-end">05:27 PM</div>
         </div>
   
         {/* Buttons Display */}
         {templates.components.find(item => item.type === "BUTTONS")?.buttons?.map((btn, index) => (
           <div key={index} className="button-bubble button-bubble-animate text-center">
             <a
               href={btn.url}
               target="_blank"
               rel="noopener noreferrer"
               className="button-text text-success text-center mb-1"
             >
               {btn.text}
             </a>
           </div>
         ))}
       </div>
     </div>
   
     {/* Mobile UI Elements */}
     <div className="mobile-top">
       <div className="mobile-camera">
         <div className="mobile-int"></div>
       </div>
       <div className="mobile-speaker"></div>
     </div>
   </div>
   
   
   
                     </div>
                   </div>
                 ) : (
                   "No template details available"
                 )}
               </div>
             </div>
           </div>
         </div>
       </div>
  );
};

export default AdminTemplateView;